// extracted by mini-css-extract-plugin
export var cyan = "TimestampTimeline-module--cyan--12e48";
export var icon = "TimestampTimeline-module--icon--e9f19";
export var message = "TimestampTimeline-module--message--a2bf0";
export var red = "TimestampTimeline-module--red--f4ae7";
export var root = "TimestampTimeline-module--root--49e3f";
export var time = "TimestampTimeline-module--time--288d1";
export var timestamp = "TimestampTimeline-module--timestamp--d84c9";
export var title = "TimestampTimeline-module--title--7dcca";